import {
  EPeriodsViewActions,
  PeriodsViewActions,
} from '@myStore/periods-view/periods-view.actions';
import {
  initialsPeriodsViewState,
  IPeriodsViewState,
} from '@myStore/periods-view/periods-view.state';

export const periodsViewReducers = (
  state = initialsPeriodsViewState,
  actions: PeriodsViewActions
): IPeriodsViewState => {
  switch (actions.type) {
    case EPeriodsViewActions.GetPeriodRequest:
      return {
        ...state,
        period: {
          ...state.period,
          isLoading: true,
        },
      };
    case EPeriodsViewActions.GetPeriodSuccess:
      return {
        ...state,
        period: {
          ...state.period,
          data: actions.period,
          isLoading: false,
        },
      };
    case EPeriodsViewActions.GetPeriodFailure:
      return {
        ...state,
        period: {
          ...state.period,
          errors: actions.errors,
          isLoading: false,
        },
      };
    case EPeriodsViewActions.ClearGetPeriod:
      return {
        ...state,
        period: {
          ...state.period,
          data: null,
          errors: null,
        },
      };
    case EPeriodsViewActions.GetGroupPeriodsRequest:
      return {
        ...state,
        isLoading: true,
      };
    case EPeriodsViewActions.GetGroupPeriodsSuccess:
      return {
        ...state,
        periods: actions.periods,
        isLoading: false,
      };
    case EPeriodsViewActions.GetGroupPeriodsFailure:
      return {
        ...state,
        isLoading: false,
        errors: actions.error,
      };
    case EPeriodsViewActions.ClearGroupPeriods:
      return {
        ...state,
        periods: null,
        errors: null,
      };

    default:
      return state;
  }
};
